module.exports = __webpack_public_path__ + "img/edge_activites_visite_ferme.ea35dc08.svg";